// @react/hooks/useTaskTaskNumbering.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskTaskNumberingStore } from '@core/stores';

/**
 * React hook for TaskNumberingScheme operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTaskTaskNumbering } from '@react/hooks';
 *
 * const TaskNumberingSchemeList = observer(() => {
 *   const store = useTaskTaskNumbering();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTaskTaskNumbering() {
  return taskTaskNumberingStore;
}
